export default "__VITE_ASSET__CdXBmBpm__"